import React, { useRef, createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import NewsFooter from './footer.jsx';
import Header from './Header.jsx';
import '../../styles/common.css';
import '../../styles/news.css';
import ScrollUp from '../common/scrollUp.jsx';
import ScrollRestoration from '../common/onWindowLoadUp.jsx';
import RouteTracker from '../common/routeTracker.jsx';

export const DeviceContext = createContext();

const News = ({ isMobile }) => {
     const newsMainContainerRef = useRef(null);
     const [mobile, setMobile] = useState(isMobile);

  return (
    <div className='main-container' ref={newsMainContainerRef}>
             <Header containerSelector={'.main-container'} mobile={mobile} />
             <ScrollRestoration containerRef={newsMainContainerRef} />
               <DeviceContext.Provider value={{mobile,setMobile,containerRef:newsMainContainerRef}}>
                  <div className='content'>
                            <Outlet />
                  </div>
             </DeviceContext.Provider>
             <NewsFooter />
             <div className='news-footer-devider'></div>
              <ScrollUp containerSelector={'.main-container'} />
             <RouteTracker />
    </div>
  );
};

export default News;
